import { useAccount } from 'modules/account/hooks/useAccount';
import { useJWTsManager } from 'domains/jwtToken/hooks/useJWTsManager';
import { useProjectsWhitelistsBlockchains } from 'domains/projects/hooks/useProjectsWhitelistsBlockchains';

export const useChainsProjects = () => {
  const { group, isAccountInitialized } = useAccount();
  const {
    isLoaded: projectsLoaded,
    jwts: projects,
    jwtsLoading: projectsLoading,
  } = useJWTsManager();
  const hasNoProjects = projects.length === 0;

  const {
    loading: projectsWithChainsLoading,
    projectsWhitelistsBlockchains: projectsWithChains,
  } = useProjectsWhitelistsBlockchains({
    group,
    projects,
    skipFetching:
      hasNoProjects ||
      projectsLoading ||
      !projectsLoaded ||
      !isAccountInitialized,
  });

  return {
    projects,
    projectsLoading,
    projectsWithChains,
    projectsWithChainsLoading,
  };
};
